module.exports = __webpack_public_path__ + "img/EA170_1-1.31c84214.jpg";